module.exports = __webpack_public_path__ + "img/head-banner.8895f8de.jpg";